<template>
  <div>
    <Title :pages="[{ icon: 'circle', page: page_title.toUpperCase() }]"></Title>

    <v-container fluid>
      <Modal
        v-if="create_access"
        :button_name="$t('Crear') + ' ' + modal_title"
        :modal_title="modal_title"
        :formBtn="formBtn"
        :dialog="dialog"
        :parent="parent"
        :service="service"
        @updateDialog="updateDialog"
        @loadList="filterList"
        :item="mainItem"
        @updateItem="(newItem) => { mainItem = newItem; }"
      />

      <!-- Filtros -->
      <v-card>
        <div class="row mb-2 mt-0">
          <div class="col-md-12" v-if="list_access">
            <div class="col-md-12 elevation-0" style="background: white">
              <div class="row pt-5">
                <div class="col-md-4 pt-0">
                  <v-radio-group v-model="selected_status" row class="mt-0 mb-0">
                    <v-radio label="Habilitado" :value="true"></v-radio>
                    <v-radio label="No habilitado" :value="false"></v-radio>
                    <v-radio label="Todos" value="all"></v-radio>
                  </v-radio-group>
                </div>
                <div class="col pt-0" style="display: flex; justify-content: end">
                  <v-btn color="info" @click="filterList">Buscar</v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-card>

      <v-card v-if="list_access">
        <v-card-title>
          <span class="text-uppercase">{{ page_title }}</span>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="search" label="Buscar" single-line hide-details></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="list"
          :search="search"
          :loading="loading"
          loading-text="Cargando..."
          :options="{ descending: true, itemsPerPage: 15 }"
          @pagination="updatePagination"
          :footer-props="{ itemsPerPageOptions: [5, 10, 15, 50, -1] }"
        >
          <template v-slot:item="props">
            <tr>
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.tipo ? props.item.tipo.name : '-' }}</td>
              <td>{{ props.item.code || '-' }}</td>
              <td>{{ props.item.parent ? props.item.parent.name : '-' }}</td>
              <td>{{ props.item.enabled ? 'SI' : 'NO' }}</td>
              <td class="justify-content-center px-0">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-if="update_access" v-on="on" small color="blue" class="mr-2" @click="editItem(props.item)">edit</v-icon>
                  </template>
                  <span>Editar</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" small color="blue" class="mr-1" @click="viewItem(props.item)">remove_red_eye</v-icon>
                  </template>
                  <span>Ver</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-if="delete_access" v-on="on" small color="red" class="mr-2" @click="deleteItem(props.item)">delete</v-icon>
                  </template>
                  <span>Eliminar</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
          <template v-slot:no-results>
            <v-alert :value="true" color="error" icon="warning">
              {{ "Busqueda sin resultados - " + search }}
            </v-alert>
          </template>
        </v-data-table>
      </v-card>

      <DialogDelete :dialog_delete="dialog_delete" @updateDialogDelete="updateDialogDelete" @deleteItemConfirm="deleteItemConfirm" />
    </v-container>
  </div>
</template>

<script>
import Constant from "@/constants/sections";
import { generalService } from "@/libs/ws/generalService";
import GenericMixin from "@/mixins/GenericMixin.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import Title from "@/components/Title.vue";
import DialogDelete from "@/components/DialogDelete.vue";
import Modal from "./Modal.vue";

export default {
  components: { Title, Modal, DialogDelete },
  mixins: [GenericMixin, RolMixin],
  data() {
    return {
      parent: this,
      service: generalService,
      page_title: "Conceptos",
      modal_title: "Concepto",
      selected_status: true,
      mainItem: {
        id: "",
        name: "",
        tipo: null,
        parent: null,
        code: "",
        enabled: true,
      },
      defaultItem: null,
      headers: [
        { text: "Nombre", align: "left", sortable: true, value: "name" },
        { text: "Tipo", align: "left", sortable: true, value: "tipo.name" },
        { text: "Código", align: "left", sortable: true, value: "code" },
        { text: "Padre", align: "left", sortable: true, value: "parent.name" },
        { text: "Habilitado", align: "left", sortable: true, value: "enabled" },
        { text: "Accion", value: "", align: "center" },
      ],
      list: [],
      dialog_delete: false,
    };
  },
  mounted() {
    this.defaultItem = JSON.parse(JSON.stringify(this.mainItem));
    this.filterList();
  },
  methods: {
    getFilterParams() {
      return { enabled: this.selected_status };
    },
    filterList() {
      this.service.setSection(Constant.SECTION_CONCEPTOS);
      this.loadList(this.service, this.getFilterParams());
    },
    deleteItemConfirm() {
      this.delete(this.service);
      this.dialog_delete = false;
      this.filterList();
    },
  },
};
</script>
